/**
 * Base app selectors that don't depend on current-user.slice.
 * This file exists to break the circular dependency between selectors.ts and current-user.slice.ts
 */
import { type DefaultRootState } from 'react-redux';

export const selectAppState = (state: DefaultRootState) => state.app;

export const selectCompany = (state: DefaultRootState) =>
  selectAppState(state).activeCompany;

export const selectApp = (state: DefaultRootState) =>
  selectAppState(state).activeApp;

export const selectCompanyName = (state: DefaultRootState) =>
  selectCompany(state)?.name;

export const selectAppDisplayName = (state: DefaultRootState) =>
  selectApp(state)?.display_name;

export const selectCompanyInternalName = (state: DefaultRootState) =>
  selectCompany(state)?.internal_name ?? '_';

export const selectCompanyId = (state: DefaultRootState): number | string =>
  selectCompany(state)?.id ?? '_';

export const selectAppId = (state: DefaultRootState) =>
  selectApp(state)?.encoded_id ?? '_';
